__turbopack_context__.v({
  "className": "caveat_f7e0b960-module__5RtdGG__className",
});
